import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, extends as _extends, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { FormControl } from './FormControl.js';
import Geosuggest from 'react-geosuggest';
import GoogleMapsLoader from 'google-maps';
import { ScrollElementToTarget } from '../../../utils/WindowHelper.js';
import { i18n } from '../../../i18n/translate.js';
import { pickDataAttributes } from '../../../utils/pickDataAttributes.js';

var AddressPickerControl = /*#__PURE__*/function (_FormControl) {
  function AddressPickerControl(props) {
    var _this;

    _classCallCheck(this, AddressPickerControl);

    _this = _callSuper(this, AddressPickerControl, [props]);

    _defineProperty(_this, "setCleanSlateAddress", function (address) {
      Object.keys(_this.state).filter(function (item) {
        return item.indexOf("".concat(_this.props.addressFieldPrefix, "_")) > -1;
      }).forEach(function (addressKey) {
        address[addressKey] = '';
      }); // manually set address_formatted to empty

      address.address_formatted = '';
    });

    _defineProperty(_this, "isValid", function () {
      var _this$input;

      return !!((_this$input = _this.input) !== null && _this$input !== void 0 && (_this$input = _this$input.validity) !== null && _this$input !== void 0 && _this$input.valid);
    });

    _defineProperty(_this, "onSuggestNoResults", function () {
      var address = {};

      _this.setCleanSlateAddress(address);

      _this.setState(address);
    });

    _defineProperty(_this, "onRef", function (geo) {
      _this.geo = geo;

      if (_this.geo) {
        var _this$geo$input;

        _this.input = (_this$geo$input = _this.geo.input) === null || _this$geo$input === void 0 ? void 0 : _this$geo$input.input;
      }
    });

    _this.onSelect = _this.onSelect.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    _this.skipSuggest = _this.skipSuggest.bind(_this);
    _this.validSuggestion = _this.validSuggestion.bind(_this);
    _this.onOpen = _this.onOpen.bind(_this);
    var initialData = props.initialData,
        addressFieldPrefix = props.addressFieldPrefix;
    _this.addressProps = AddressPickerControl.addressPropVals.map(function (prop) {
      return "".concat(addressFieldPrefix).concat(prop);
    });
    var value = '';

    if (initialData) {
      if (initialData.location_formatted_address) {
        value = initialData.location_formatted_address;
      } else if (initialData["".concat(addressFieldPrefix, "_formatted")]) {
        value = initialData["".concat(addressFieldPrefix, "_formatted")];
      } else if (initialData["".concat(addressFieldPrefix, "_street_number")]) {
        value = "".concat(initialData["".concat(addressFieldPrefix, "_street_number")], " ").concat(initialData["".concat(addressFieldPrefix, "_route")], " ").concat(initialData["".concat(addressFieldPrefix, "_locality")], ", ").concat(initialData["".concat(addressFieldPrefix, "_administrative_area_level_1")]);
      }
    }

    _this.addressSelected = !!value;
    _this.state = {
      value: value
    };

    _this.addressProps.forEach(function (prop) {
      _this.state[prop] = initialData && initialData[prop] ? initialData[prop] : '';
    });

    if (initialData && typeof props.onDataLoaded === 'function') {
      props.onDataLoaded(_this.state.value);
    }

    return _this;
  }

  _inherits(AddressPickerControl, _FormControl);

  return _createClass(AddressPickerControl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      GoogleMapsLoader.KEY = this.props.googleMapsApiKey;
      GoogleMapsLoader.VERSION = '3.34';
      GoogleMapsLoader.LIBRARIES = ['places'];
      GoogleMapsLoader.load(function (google) {
        return _this2.setState({
          googleMaps: google.maps
        });
      });
    }
  }, {
    key: "skipSuggest",
    value: function skipSuggest(suggest) {
      return !this.validSuggestion(suggest);
    }
  }, {
    key: "onSelect",
    value: function onSelect(suggest) {
      var _this3 = this;

      if (!this.validSuggestion(suggest)) {
        this.addressSelected = false;
        return;
      }

      this.input.setCustomValidity('');
      this.addressSelected = true; // extract the data and place it where we can save later

      var address = {}; // we have to clean state of old key from any previous address

      this.setCleanSlateAddress(address);
      address.value = suggest.label;
      suggest.gmaps.address_components.forEach(function (component) {
        component.types.forEach(function (type) {
          if (_this3.addressProps.includes("".concat(_this3.props.addressFieldPrefix, "_").concat(type))) {
            address["".concat(_this3.props.addressFieldPrefix, "_").concat(type)] = component.long_name;
          }
        });
      });
      address["".concat(this.props.addressFieldPrefix, "_latitude")] = suggest.gmaps.geometry.location.lat();
      address["".concat(this.props.addressFieldPrefix, "_longitude")] = suggest.gmaps.geometry.location.lng();
      address["".concat(this.props.addressFieldPrefix, "_google_place_id")] = suggest.gmaps.place_id;
      this.setState(address);

      if (typeof this.props.onChange === 'function') {
        this.props.onChange(suggest);
      }

      if (typeof this.props.onValueChange === 'function') {
        this.props.onValueChange(address);
      }

      var valid = this.isValid();

      if (typeof this.props.setError === 'function') {
        this.props.setError(!valid);
      }
    }
  }, {
    key: "validSuggestion",
    value: function validSuggestion(suggest) {
      var statesAndCitiesValidTypes = this.props.includeStatesAndCities ? ['administrative_area_level_1', 'locality'] : [];
      var countriesValidTypes = this.props.includeCountries ? ['country'] : [];

      if (suggest) {
        var validTypes = ['street_address', 'route', 'premise', 'subpremise', 'point_of_interest'].concat(statesAndCitiesValidTypes, countriesValidTypes);
        var suggestionTypes = suggest.gmaps ? suggest.gmaps.types : suggest.types;
        return suggestionTypes.some(function (type) {
          return validTypes.includes(type);
        });
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur(userInput) {
      if (typeof this.props.onBlur === 'function') {
        this.props.onBlur(userInput);
      }

      if (!this.addressSelected) {
        var clearAddress = {};
        this.addressProps.forEach(function (prop) {
          return clearAddress[prop] = undefined;
        });
        this.setState(clearAddress);
        var message = userInput ? i18n.t('Please select a valid address') : i18n.t('This field is required');
        this.input.setCustomValidity(message);

        if (typeof this.props.setError === 'function') {
          this.props.setError(true, message);
        }
      }
    }
  }, {
    key: "checkError",
    value: function checkError() {
      if (typeof this.props.setError === 'function') {
        if (!this.isValid()) {
          this.props.setError(true, i18n.t('Please select a valid address'));
        } else {
          this.props.setError(false);
        }
      }
    }
  }, {
    key: "onOpen",
    value: function onOpen() {
      this.addressSelected = false;
      var el = document.getElementById(this.props.scrollContainerId);
      var target = document.activeElement;
      ScrollElementToTarget(el, target, 155);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var dataAttributes = pickDataAttributes(this.props);
      var ariaLabel = this.props.ariaLabel || 'Address (Use keyboard for predictive text)';
      return /*#__PURE__*/React.createElement("div", {
        onFocus: this.props.onFocus
      }, this.state.googleMaps ? /*#__PURE__*/React.createElement(Geosuggest, _extends({}, dataAttributes, {
        "aria-label": ariaLabel,
        "aria-required": this.props.required,
        autoActivateFirstSuggest: true,
        disabled: this.props.disabled,
        googleMaps: this.state.googleMaps,
        id: this.props.id,
        initialValue: this.state.value,
        inputClassName: "form-control",
        onBlur: this.onBlur,
        onFocus: this.onOpen,
        onSuggestNoResults: this.onSuggestNoResults,
        onSuggestSelect: this.onSelect,
        placeholder: this.props.placeholder,
        ref: this.onRef,
        required: this.props.required,
        skipSuggest: this.skipSuggest
      })) : null, this.addressProps.map(function (prop) {
        return /*#__PURE__*/React.createElement("input", {
          type: "hidden",
          value: _this4.state[prop],
          key: prop,
          disabled: _this4.props.disabled,
          name: _this4.props.formatAddressPropName ? _this4.props.formatAddressPropName(prop) : prop
        });
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var addressFieldPrefix = props.addressFieldPrefix,
          initialData = props.initialData,
          valueOverride = props.valueOverride;
      var value = '';

      if (valueOverride) {
        if (initialData.location_formatted_address && initialData.location_formatted_address !== state.value) {
          value = initialData.location_formatted_address;
        } else if (initialData["".concat(addressFieldPrefix, "_formatted")] && initialData["".concat(addressFieldPrefix, "_formatted")] !== state.value) {
          value = initialData["".concat(addressFieldPrefix, "_formatted")];
        } else if (initialData["".concat(addressFieldPrefix, "_street_number")] && initialData["".concat(addressFieldPrefix, "_street_number")] !== state.value) {
          value = "".concat(initialData["".concat(addressFieldPrefix, "_street_number")], " ").concat(initialData["".concat(addressFieldPrefix, "_route")], " ").concat(initialData["".concat(addressFieldPrefix, "_locality")], ", ").concat(initialData["".concat(addressFieldPrefix, "_administrative_area_level_1")]);
        }

        return {
          value: value
        };
      }

      return {
        value: state.value
      };
    }
  }]);
}(FormControl);

_defineProperty(AddressPickerControl, "propTypes", {
  addressFieldPrefix: PropTypes.string,
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  fieldClassName: PropTypes.string,
  formatAddressPropName: PropTypes.func,
  googleMapsApiKey: PropTypes.string.isRequired,
  id: PropTypes.string,
  includeCountries: PropTypes.bool,
  includeStatesAndCities: PropTypes.bool,
  initialData: PropTypes.object,
  inputClassName: PropTypes.string,
  onChange: PropTypes.func,
  onDataLoaded: PropTypes.func,
  onValueChange: PropTypes.func,
  placeholder: PropTypes.string,
  scrollContainerId: PropTypes.string,
  valueOverride: PropTypes.bool
});

_defineProperty(AddressPickerControl, "defaultProps", Object.assign({}, FormControl.defaultProps, {
  addressFieldPrefix: 'location',
  includeStatesAndCities: false,
  includeCountries: false
}));

_defineProperty(AddressPickerControl, "addressPropVals", ['_administrative_area_level_1', '_administrative_area_level_2', '_country', '_latitude', '_locality', '_longitude', '_neighborhood', '_postal_code', '_route', '_street_number']);

AddressPickerControl.displayName = "AddressPickerControl";
export { AddressPickerControl };